import { useSelector } from "react-redux";
import { UserAppSettings } from "../api/fetchUserAppSettings/types";
import { RootState } from "../app/rootReducer";

const permissionsService = () => {
  const userAppSettings: UserAppSettings | null = useSelector(
    (state: RootState) => state.userAppSettings.userAppSettings,
  );

  const hasApplicationAccess = (applicationName: string): boolean => {
    if (!userAppSettings || !userAppSettings.applicationAccess) {
      return false;
    }
    return userAppSettings.applicationAccess.includes(applicationName);
  };

  const hasCertainPathCompany = () => {
    if (!userAppSettings) return false;
    return userAppSettings.isCertainPathCompany;
  };

  /**
   * Check if the user has a specific permission.
   * Permissions are nav-item based strings like "stochastic-dashboard", "financial-reports-profit-and-loss".
   */
  const hasPermission = (permission: string): boolean => {
    if (!userAppSettings || !userAppSettings.permissions) {
      return false;
    }
    return userAppSettings.permissions.includes(permission);
  };

  return {
    hasApplicationAccess,
    hasPermission,
    hasCertainPathCompany,
  };
};

export default permissionsService;
